import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Grid
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {

    render() {
        const uncompletedProductListDetails = this.props.uncompletedProductListDetails;
        const data = this.props.searchData;

        return (
            <div align='left'>
                <h3><center><u>Uncompleted Product List Report</u></center></h3>
                <div >&nbsp;</div>
                <h4><center>Group - {data.groupName}</center></h4>
                <h4><center>Date - {data.date} </center></h4>
                <div>&nbsp;</div>
                <Box minWidth={1150}>

                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">ProductCode</TableCell>
                                    <TableCell align="left">ProductName</TableCell>
                                    <TableCell align="left">ProductCategoryName</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {uncompletedProductListDetails.map((row) => (
                                    <TableRow key={row.productCode}>
                                        <TableCell align="left">
                                            {row.productCode !== null ? row.productCode : '-'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.productName !== null ? row.productName : '-'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.productCategoryName !== null ? row.productCategoryName : '-'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}

